module.exports = {"510104020":"督院街街道","510104021":"盐市口街道","510104022":"春熙路街道","510104023":"书院街街道","510104024":"合江亭街道","510104025":"水井坊街道","510104026":"牛市口街道","510104027":"龙舟路街道","510104028":"双桂路街道","510104029":"莲新街道","510104030":"沙河街道","510104031":"东光街道","510104032":"狮子山街道","510104035":"成龙路街道","510104036":"柳江街道","510104037":"三圣街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510104.json
// module id = 2074
// module chunks = 0